import { Component, OnInit, TemplateRef, inject } from '@angular/core';
import {AuthenticationService, authUserType, profileType, reRgType} from 'app/services/auth.service';
import {LoaderService} from "app/services/loader.service";
import { NgbModal, NgbTooltip } from "@ng-bootstrap/ng-bootstrap";
import {AppConfig} from "app/app.config";
import {AdvisorContactComponent} from "app/modules/shared/advisor-contact.component";
import {ActivatedRoute, Router} from "@angular/router";
import {APIService} from 'app/services/api.service';
import { NgClass } from '@angular/common';
import { VerticalNavComponent } from '../shared/vertical-nav/vertical-nav.component';
import { UserProfileCardComponent } from './user-profile-card/user-profile-card.component';
import { RequestToUpdateInformationComponent } from './request-to-update-information/request-to-update-information.component';
import { ProfileResetPasswordComponent } from './profile-reset-password.component';
import { AdvisorContactComponent as AdvisorContactComponent_1 } from '../shared/advisor-contact.component';

type LinkType = {
  name: string,
  icon?: string,
  tag: string,
  clientOnly?: boolean
};
type UserWithAccessType = {
  Name: string,
  CreatedAt: Date
}

@Component({
    selector: 'nwm-profile-myinfo',
    templateUrl: 'profile-myinfo.component.html',
    styleUrls: ['./profile-myinfo.component.scss'],
    imports: [NgClass, VerticalNavComponent, NgbTooltip, UserProfileCardComponent, RequestToUpdateInformationComponent, ProfileResetPasswordComponent, AdvisorContactComponent_1]
})

export class ProfileMyInfoComponent implements OnInit {
  private api = inject(APIService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  config = inject(AppConfig);
  auth = inject(AuthenticationService);
  modalService = inject(NgbModal);
  private loaderService = inject(LoaderService);

  selectedProfile!: profileType;
  relatedProfiles: profileType[] = [];
  accOrLawyersProfiles: profileType[] = [];
  links: LinkType[] = [
    {name: 'Contact Information', icon: 'person', tag: 'contact-info'},
    {name: 'Multi-factor Authentication', icon: 'security', tag: 'mfa'},
    {name: 'Change Password', icon: 'lock', tag: 'change-password'},
    {name: '-', tag: '', clientOnly: true},
    {name: 'Reporting Groups', tag: '', clientOnly: true},
    {name: '-', tag: '', clientOnly: true},
    {name: 'Legal', icon: 'policy', tag: 'legal'}
  ];
  activeLink: LinkType = this.links[0];
  showProfileForm = false;
  usersWithAccessToCurrentReRg: UserWithAccessType[] = [];
  contactFormTitle = '';
  user?: authUserType;
  profile?: profileType;
  isImpersonated = false;
  isLoading = false;
  canEditKYC = false;
  canUpdateContact = false;
  reRg?: reRgType;
  linkSelected = false;

  ngOnInit() {
    this.isImpersonated = !!sessionStorage.getItem('guid');

    this.user = this.auth.getUser()!;
    this.profile = this.auth.getProfile()!;

    const reRgLinks:LinkType[]= [];
    this.user?.reRgs?.forEach(r=> {
      reRgLinks.push({name: r.ClientName, icon: '', tag: 'rg/'+r.ReRgId});
    });
    if (reRgLinks.length > 0) {
      this.links.splice(5,0,...reRgLinks);
    } else {
      this.links.splice(3,3);
    }

    this.route.params.subscribe(params => {
      this.linkSelected = !!params['tag'];
      if (!params['tag'] || params['tag'] === 'contact-info') {
        this.activeLink = this.links[0];
      } else if (params['tag']) {
        if (params['tag'] === 'rg') {
          this.reRg = this.user?.reRgs?.find(r=>r.ReRgId===parseInt(params['rerg']));
          if (!this.reRg) {
            this.router.navigate(['/error/client/8']);
            return;
          } else {
            this.usersWithAccessToCurrentReRg = this.reRg.UsersWithAccess && JSON.parse(this.reRg.UsersWithAccess) || [];
            this.getReRgProgfile(this.reRg.ReRgId);
          }
        }
        this.activeLink = this.links.find(item => item.tag === params['tag']+(params['rerg'] ? '/'+params['rerg']:'')) ?? this.links[0];
      }
    });
  }

  getReRgProgfile(reRgId:number) {
    this.relatedProfiles = [];
    this.accOrLawyersProfiles = [];
    this.canEditKYC = !!this.reRg?.Access?.includes('Edit_KYC');
    this.canUpdateContact = !!this.reRg?.Access?.includes('Update_Personal_Information');
    if (!reRgId) return;
    this.loading(true);
    const rerg = this.user?.reRgs?.find(f=>f.ReRgId===reRgId);
    this.api.getProfileByReRgId(reRgId).subscribe(data=>{
      if (rerg?.RergType==='PGF') {
        data[1].forEach(f=>{
          if (f.AdvisorType === 'Donor' || f.AdvisorType === 'Successor') {
            this.relatedProfiles.push(f);
          } else {
            this.accOrLawyersProfiles.push(f);
          }
        });
        this.relatedProfiles = this.relatedProfiles.sort((a,b)=>(a.AdvisorType||'')>(b.AdvisorType||'')?1:-1);
      } else {
        this.relatedProfiles = data[0];
        this.accOrLawyersProfiles = data[1];
      }
      this.loading(false);
    }, ()=>{
      this.loading(false);
    });
  }

  loading(isLoading: boolean) {
    this.loaderService.display(isLoading, 'ReRgProgfile', 0);
    this.isLoading = isLoading;
  }

  navigateToDefaultTab(): void {
    this.router.navigate(['/profile']);
  }

  changeRoute(linkName:string): void {
    this.showProfileForm = false;
    const activeTab = this.links.find(item => item.name === linkName)?.tag ?? '';
    this.router.navigate(['/profile/' + activeTab]);
  }

  selectProfile(profile: profileType): void {
    this.selectedProfile = profile;
    this.showProfileForm = true;
  }

  /**
   * it would open a modal to send message & upload documents to the team
   * @param content
   */
  openModalToContactAdvisor(content: TemplateRef<AdvisorContactComponent>, contactFormTitle = 'Contact Your Advisory Team') {
    this.contactFormTitle = contactFormTitle;
    this.modalService.open(content, { size: 'lg' })
  }
}
